<div class="rx-card">
	<div class="rx-card-title">
		<div class="rx-title-row rx-app-flex-container-row rx-app-flex-container-row--align-center">
			<div>{{ 'DentureDetails.SectionTitle' | translate }}:</div>
		</div>
	</div>
	<form class="rx-card-body rx-app-flex-container-row rx-app-flex-container-row--justify-space-between" [formGroup]="form">
		<ng-container *ngIf="dentureFieldsVisibility$ | async as fieldsVisibility">
		<div class="rx-app-flex-container-column rx-app-flex--half">
			<rx-select
				*ngIf="fieldsVisibility.stage"
				[id]="'stage'"
				[label]="'DentureDetails.StageTitle' | translate"
				[formControl]="stageControl"
				[options]="stages$ | async"
				[isDisabled]="(isReadOnly$ | async)"
				[isCancellable]="true"
				(disableChangeEvent)="cleanControlWhenDisabled($event, stageControl)"
				name="stageControl"
			>
			</rx-select>

			<rx-moulds-dropdown
				*ngIf="fieldsVisibility.mould"
				[id]="'mould'"
				[label]="'DentureDetails.MouldTitle' | translate"
				[formControl]="mouldControl"
				[options]="moulds$ | async"
				[isReadOnly]="isReadOnly$ | async"
				[isCancellable]="true"
				name="mouldControl"
			>
			</rx-moulds-dropdown>

			<div class="rx-app-flex rx-app-flex-container-column rx-app-flex-container-column--justify-center">
				<div class="sides rx-app-flex">
					<div class="toggle-pair">
						<tlk-slide-toggle
							[formControl]="isUpperControl"
							name="isUpperControl"
							[id]="'isUpper'"
							labelPosition="left"
							[isDisabled]="(dentureUpperSectionIsReadonly$ | async) || (isReadOnly$ | async)"
						>{{ 'DentureDetails.UpperDentureTitle' | translate }}</tlk-slide-toggle>
					</div>
					<div class="toggle-pair">
						<tlk-slide-toggle
							[formControl]="isLowerControl"
							name="isLowerControl"
							[id]="'isLower'"
							labelPosition="left"
							[isDisabled]="(dentureLowerSectionIsReadonly$ | async) || (isReadOnly$ | async)"
						>{{ 'DentureDetails.LowerDentureTitle' | translate }}</tlk-slide-toggle>
					</div>
				</div>
				<mat-divider></mat-divider>
			</div>
		</div>
		<div class="rx-app-flex-container-column rx-app-flex--half">
			<rx-select
				*ngIf="fieldsVisibility.shadeSystem"
				[id]="'shadeSystem'"
				[label]="'DentureDetails.ShadeSystemTitle' | translate"
				[formControl]="shadeSystemControl"
				[options]="shadeSystems"
				[isDisabled]="isReadOnly$ | async"
				[isCancellable]="false"
				[isRequired]="(shouldValidateForSend$ | async)"
				name="shadeSystemControl"
			>
			</rx-select>
			<rx-select
				*ngIf="(teethShadesHasOptions$ | async) && fieldsVisibility.teethShade"
				[id]="'teethShade'"
				[label]="'DentureDetails.TeethShadeTitle' | translate"
				[formControl]="teethShadeControl"
				[options]="teethShades$ | async"
				name="teethShadeControl"
				[isDisabled]="!isTeethShadeEnabled"
				[isReadOnly]="isReadOnly$ | async"
				[isCancellable]="true"
				[isRequired]="(shouldValidateForSend$ | async)"
				[getOptionId]="teethShadeOptionId"
				[getOptionName]="teethShadeOptionName"
				[compareWith]="teethShadeCompareWith"
			>
			</rx-select>
			<rx-text-input
				*ngIf="!(teethShadesHasOptions$ | async) && fieldsVisibility.teethShade"
				[label]="'DentureDetails.TeethShadeTitle' | translate"
				[formControl]="teethShadeControl"
				[isDisabled]="!isTeethShadeEnabled || (isReadOnly$ | async)"
				[maxlength]="maxTeethShadeLength"
				autocomplete="off"
				name="teethShadeControl"
			></rx-text-input>
			<rx-select
				*ngIf="fieldsVisibility.gingival"
				[id]="'gingivalShade'"
				[label]="'DentureDetails.GingivalShadeTitle' | translate"
				[formControl]="gingivalShadeControl"
				[options]="gingivalShades$ | async"
				[isDisabled]="isReadOnly$ | async"
				[isCancellable]="true"
				[isRequired]="(shouldValidateForSend$ | async)"
				name="gingivalShadeControl"
			>
			</rx-select>
		</div>
		</ng-container>
	</form>
</div>
